var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 17.8L18.9 19c-1.3 1.2-3.3 1.4-4.8.4-2-1.2-3.9-2.6-5.6-4.2-1.6-1.7-3.1-3.5-4.4-5.3-1-1.4-.8-3.3.4-4.5l1.3-1.2c.2-.2.5-.3.8-.3s.6.1.8.3l2.1 2c.3.2.4.5.4.8s-.1.5-.3.7l-1 .9c-.2.2-.2.6-.1.9.7 1.2 1.6 2.3 2.6 3.3 1.1.9 2.2 1.8 3.5 2.5.3.2.7.1.9-.1l.9-.9c.4-.4 1.2-.4 1.6 0l2.1 2c.2.2.3.5.3.8.1.3 0 .5-.2.7z"
  })));
}

export default SvgPhone;